export type AccessList = Array<string>;

//Lista wspólnych dostępów
const commonAccesses: AccessList = [
  'tab-moje-przedmioty',
  'tab-karty-przedmiotow',
  'tab-studenci',
  'karta-przedmiotu',
  'strona-przedmiotu',
  'strona-studenta',
];

// Lista dostępów dla użytkownika o przypisanej roli "supernauczyciel"
export const superTeacherAccesses: AccessList = [
  ...commonAccesses,
  'supernauczyciel-panel',
];

//Lista dostępów dla użytkownika o przypisanej roli "kierownik przedmiotu "
export const subjectManagerAccesses: AccessList = [
  ...commonAccesses,

];

//Lista dostępów dla użytkownika o przypisanej roli "wykładowca"
export const instructorAccesses: AccessList = [
  ...commonAccesses,

];